var map = {
	"./1/symbol_0.png": "000a",
	"./1/symbol_1.png": "d9b7",
	"./1/symbol_10.png": "7a24",
	"./1/symbol_11.png": "c3e6",
	"./1/symbol_12.png": "4844",
	"./1/symbol_13.png": "842b",
	"./1/symbol_14.png": "2e52",
	"./1/symbol_15.png": "5bdb",
	"./1/symbol_16.png": "fb0b",
	"./1/symbol_17.png": "d818",
	"./1/symbol_18.png": "658a",
	"./1/symbol_2.png": "2304",
	"./1/symbol_3.png": "304d",
	"./1/symbol_4.png": "abf3",
	"./1/symbol_5.png": "835a",
	"./1/symbol_6.png": "6133",
	"./1/symbol_7.png": "2859f",
	"./1/symbol_8.png": "4709",
	"./1/symbol_9.png": "c3d7"
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = "67ac";